import {
    CHANGE_FORM_DATA,
    CHANGE_MANAGE_SOL_ACCOUNT_SETTINGS,
    RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR,
    RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR_PASSWORD,
    RECEIVE_FAILED_RESPONSE_GET_SOLICITOR_DETAILS,
    RECEIVE_GET_ACCEPTED_TOBA,
    RECEIVE_GET_SOLICITOR_DETAILS,
    RECEIVE_UPDATE_SOLICITOR_PASSWORD_RESPONSE,
    RECEIVE_UPDATE_SOLICITOR_RESPONSE,
    REQUEST_GET_ACCEPTED_TOBA,
    REQUEST_GET_ACCEPTED_TOBA_FAIL,
    REQUEST_GET_SOLICITOR_DETAILS,
    REQUEST_UPDATE_SOLICITOR_DETAILS,
    REQUEST_UPDATE_SOLICITOR_PASSWORD,
    REQUEST_GET_LAWSYS_DETAILS,
    RECEIVE_GET_LAWSYS_DETAILS,
    RECEIVE_FAILED_RESPONSE_GET_LAWSYS_DETAILS,
    TOGGLE_ERROR
} from "./index";

export function changeFormData(field, data) {
    return {
        type: CHANGE_FORM_DATA,
        payload: {
            key: field,
            value: data
        }
    }
}


//function to get the solicitors details from the api
export function requestGetSolicitorDetails(id) {
    return {
        type: REQUEST_GET_SOLICITOR_DETAILS,
        payload: id
    }
}

//function that receives the solicitor details from the api
export function receiveGetSolicitorDetails(solicitorDetails) {
    return {
        type: RECEIVE_GET_SOLICITOR_DETAILS,
        payload: solicitorDetails
    }
}

//function that receives failed response for getting the solicitor details from the api
export function receiveFailedResponseGetSolicitorDetails(solicitorDetails) {
    return {
        type: RECEIVE_FAILED_RESPONSE_GET_SOLICITOR_DETAILS,
        payload: solicitorDetails
    }
}


//function to get the lawsys details from the api
export function requestGetLawsysDetails(payload) {
    return {
        type: REQUEST_GET_LAWSYS_DETAILS,
        payload
    }
}

//function that receives the lawsys details from the api
export function receiveGetLawsysDetails(payload) {
    return {
        type: RECEIVE_GET_LAWSYS_DETAILS,
        payload
    }
}

//function that receives failed response for getting the lawsys details from the api
export function receiveFailedResponseGetLawsysDetails(payload) {
    return {
        type: RECEIVE_FAILED_RESPONSE_GET_LAWSYS_DETAILS,
        payload
    }
}



//function that makes the PUT request to update the solicitor data
export function requestUpdateSolicitorDetails(sendBody) {
    return {
        type: REQUEST_UPDATE_SOLICITOR_DETAILS,
        payload: sendBody
    }
}

//function that receives the response form the put request to update the solicitor data
export function receiveUpdateSolicitorResponse(updatedSolicitorDetails) {
    return {
        type: RECEIVE_UPDATE_SOLICITOR_RESPONSE,
        payload: updatedSolicitorDetails
    }
}

export function receiveBadResponseUpdateSolicitor(badResponse){
    return {
        type: RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR,
        payload: badResponse
    }
}


//function that changed the error type status
export function toggleError(errorType, errorMessage){
    return {
        type: TOGGLE_ERROR,
        payload: {
            key: errorType,
            value: errorMessage
        }
    }
}

//action that requests get accepted toba
export function requestGetAcceptedToba(id) {
    return {
        type: REQUEST_GET_ACCEPTED_TOBA,
        payload: id
    }
}

//action that receives get accepted toba
export function receiveGetAcceptedToba(response) {
    return {
        type: RECEIVE_GET_ACCEPTED_TOBA,
        payload: response
    }
}

export function requestGetAcceptedTobaFail(payload) {
    return {
        type: REQUEST_GET_ACCEPTED_TOBA_FAIL,
        payload: payload
    }
}


//action that changed redux settings
export function changeManageSolAccountSettings(key, value) {
    return {
        type: CHANGE_MANAGE_SOL_ACCOUNT_SETTINGS,
        payload: {
            key: key,
            value: value
        }
    }
}


//function that makes the PATCH request to update the solicitor password
export function requestUpdateSolicitorPassword(sendBody) {
    return {
        type: REQUEST_UPDATE_SOLICITOR_PASSWORD,
        payload: sendBody
    }
}

//function that receives the response form the patch request to update the solicitor password
export function receiveUpdateSolicitorPasswordResponse(updatedSolicitorDetails) {
    return {
        type: RECEIVE_UPDATE_SOLICITOR_PASSWORD_RESPONSE,
        payload: updatedSolicitorDetails
    }
}

export function receiveBadResponseUpdateSolicitorPassword(badResponse){
    return {
        type: RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR_PASSWORD,
        payload: badResponse
    }
}
